function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 10.956c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm-11 4v-5h2v5H9zm1-6a1 1 0 100-2 1 1 0 000 2z",
  fill: "#A7AEB7"
});

var SvgBannerWarningDisable = function SvgBannerWarningDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAxMC45NTYxQzIwIDE2LjQ3ODkgMTUuNTIyOCAyMC45NTYxIDEwIDIwLjk1NjFDNC40NzcxNSAyMC45NTYxIDAgMTYuNDc4OSAwIDEwLjk1NjFDMCA1LjQzMzIxIDQuNDc3MTUgMC45NTYwNTUgMTAgMC45NTYwNTVDMTUuNTIyOCAwLjk1NjA1NSAyMCA1LjQzMzIxIDIwIDEwLjk1NjFaTTkgMTQuOTU2MVY5Ljk1NjA1SDExVjE0Ljk1NjFIOVpNMTAgOC45NTYwNUMxMC41NTIzIDguOTU2MDUgMTEgOC41MDgzNCAxMSA3Ljk1NjA1QzExIDcuNDAzNzcgMTAuNTUyMyA2Ljk1NjA1IDEwIDYuOTU2MDVDOS40NDc3MSA2Ljk1NjA1IDkgNy40MDM3NyA5IDcuOTU2MDVDOSA4LjUwODM0IDkuNDQ3NzIgOC45NTYwNSAxMCA4Ljk1NjA1WiIgZmlsbD0iI0E3QUVCNyIvPgo8L3N2Zz4K";
export { SvgBannerWarningDisable as ReactComponent };